module.exports = __webpack_public_path__ + "static/img/product_society_society_jjjl.54ef15c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_jjjl.png
// module id = xXYU
// module chunks = 0